import classNames from "classnames";
import { memo, useEffect, useRef, useState } from "react";
import Spinner from "./Spinner";
const BboxViewer = ({ src, bboxes, isLoading, onDelete, hasTools, isSelectable, onChange }) => {

    const imgRef = useRef(null);


    const [dimensions, setDimensions] = useState({});

    const [imgWidth, setImgWidth] = useState(undefined);

    const onImgLoad = ({ target }) => {

        setDimensions({
            height: target.offsetHeight,
            width: target.offsetWidth
        });

        setImgWidth(imgRef.current ? imgRef.current.offsetWidth : 0);
    };

    const maxWidth = dimensions && dimensions.height ? (400.0 / dimensions.height) * dimensions.width : undefined;

    const style = maxWidth ? { maxWidth: maxWidth + "px" } : {};


    const onClick = selectedIdx => {
        if (onChange) {
            const newBoxes = bboxes.map((x, idx) => {
                return {
                    ...x,
                    selected: idx === selectedIdx ? !x.selected : x.selected,
                };
            });
            onChange(newBoxes);
        };

    };

    useEffect(() => {
        setImgWidth(imgRef.current ? imgRef.current.offsetWidth : 0);
    }, [imgRef.current, src]);

    useEffect(() => {
        setImgWidth(undefined);
    }, [src]);

    return <div className="bbox-viewer-container" style={imgWidth ? { "width": imgWidth + "px" } : {}}>

        <img className="bbox-annotated-image" src={src} onLoad={onImgLoad} ref={imgRef} />
        {src && isLoading ? <Spinner style={{ position: "absolute" }} /> : ""}


        {src && !isLoading && bboxes ? bboxes.map((bbox, idx) =>
            <span
                idx={idx}
                key={idx}
                className={classNames("annotation", { "selectable": true, "selected": bbox.selected })}
                onClick={() => onClick(idx)}
                style={{
                    left: bbox.box.xmin * 100 + '%',
                    top: bbox.box.ymin * 100 + '%',
                    width: (bbox.box.xmax - bbox.box.xmin) * 100 + '%',
                    height: (bbox.box.ymax - bbox.box.ymin) * 100 + '%',
                }}
            ></span>)
            : ''}
    </div>;
};

export default memo(BboxViewer);
